import React from 'react'
import { Container } from 'react-awesome-styled-grid'

import { Button } from '@superlogica/button'
import PropTypes from 'prop-types'

import Illustration from '../helpers/Illustration'
import * as S from './styled'

const Hero = ({
  badge,
  headText,
  bodyText,
  action,
  illustration,
  appearance,
  ...props
}) => (
  <S.HeroWrapper
    appearance={appearance}
    paddingTop={120}
    paddingBottom={60}
    {...props}
  >
    <Container>
      <S.HeroContent>
        <S.HeroCaption>
          {badge && <S.HeroBadge {...badge} />}
          {headText && (
            <S.HeroTitle appearance="bigger" color="neutral900">
              {headText}
            </S.HeroTitle>
          )}
          {bodyText && (
            <S.HeroText dangerouslySetInnerHTML={{ __html: bodyText }} />
          )}
          {action && (
            <Button
              as="a"
              href="https://superlogica.com/trial"
              target="_blank"
              className="d-block d-sm-inline-block"
              title={action.label}
              color={action.color || 'blue500'}
            >
              {action.label}
            </Button>
          )}
        </S.HeroCaption>
        {illustration && (
          <S.HeroFigure className="d-none d-md-block">
            <Illustration name={illustration} />
          </S.HeroFigure>
        )}
      </S.HeroContent>
    </Container>
  </S.HeroWrapper>
)

Hero.defaultProps = {}

Hero.propTypes = {
  badge: PropTypes.object,
  headText: PropTypes.string,
  bodyText: PropTypes.string,
  action: PropTypes.object,
  illustration: PropTypes.string,
  appearance: PropTypes.string,
  noPadding: PropTypes.bool,
  paddingTop: PropTypes.number,
  paddingBottom: PropTypes.number,
  paddingLeft: PropTypes.number,
  paddingRight: PropTypes.number,
  bgColor: PropTypes.string,
  bgGradient: PropTypes.array,
  afterSkew: PropTypes.oneOf(['to-left', 'to-right'])
}

export default Hero
